// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Email = function Email(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.5 4.375A.627.627 0 0 0 1.875 5v.863l6.738 5.532a2.185 2.185 0 0 0 2.778 0l6.734-5.532V5a.627.627 0 0 0-.625-.625zm-.625 3.914V15c0 .344.281.625.625.625h15a.627.627 0 0 0 .625-.625V8.29l-5.547 4.554a4.06 4.06 0 0 1-5.156 0zM0 5c0-1.379 1.121-2.5 2.5-2.5h15C18.879 2.5 20 3.621 20 5v10c0 1.379-1.121 2.5-2.5 2.5h-15A2.5 2.5 0 0 1 0 15z"
  }));
};
